import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/apiClient";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email: email.trim(), password: password.trim() });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "h-12 w-full border border-[#262626] bg-[#050505] px-4 text-white placeholder:text-neutral-600 outline-none focus:border-[#D4CBB3]";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#262626] bg-[#0A0A0A] p-10">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#262626]">
          <Lock className="h-5 w-5 text-[#D4CBB3]" strokeWidth={1.5} />
        </div>
        <h1 className="mt-8 font-display text-3xl font-light tracking-tight text-white">
          Administration
        </h1>
        <p className="mt-3 font-light text-neutral-400">Logga in för att se OSA-svaren.</p>

        <form onSubmit={submit} noValidate className="mt-8 space-y-4">
          <input
            type="text"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-post"
            autoFocus
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            data-testid="admin-email-input"
            className={inputClass}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Lösenord"
            data-testid="admin-password-input"
            className={inputClass}
          />
          {error && (
            <p className="text-sm text-red-400" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="h-12 w-full bg-[#D4CBB3] text-sm font-medium uppercase tracking-[0.15em] text-[#050505] transition-colors hover:bg-[#C2B79A] disabled:opacity-50"
          >
            {loading ? "Loggar in…" : "Logga in"}
          </button>
        </form>
      </div>
    </div>
  );
}
